/* usergroup/types */

import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
  }),
  t.partial({
    Permission: t.any
  }),
]);

const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
});

export type Data = t.TypeOf<typeof DataCodec>;

export const UserGroupCodec = t.type({
  errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
  data: tOptional(t.array(DataCodec)),
});

export type UserGroup = t.TypeOf<typeof UserGroupCodec>;

export enum UserGroupActionTypes {
  FETCH = "@@userGroup/FETCH",
  FETCH_SUCCESS = "@@userGroup/FETCH_SUCCESS",
  FETCH_ERROR = "@@userGroup/FETCH_ERROR",
  SAVE_REQUEST = "@@userGroup/SAVE_REQUEST",
  SAVE_SUCCESS = "@@userGroup/SAVE_SUCCESS",
  SAVE_ERROR = "@@userGroup/SAVE_ERROR",
  DELETE_REQUEST = "@@userGroup/DELETE_REQUEST",
  DELETE_SUCCESS = "@@userGroup/DELETE_SUCCESS",
  DELETE_ERROR = "@@userGroup/DELETE_ERROR",
}

export interface UserGroupState {
  readonly loading: boolean;
  readonly data: UserGroup | undefined;
  readonly errors?: string;
}
